import { http } from '@/core/helpers/http.helper';
import { RecruitmentTechnologies } from './recruitment-technologies.interface';
export class RecruitmentTechnologiesService {
   async getAccessToken() {
      const response = await http.get<RecruitmentTechnologies>('/recruitment-technologies/access-token');
      return response.data;
   }
}
